import { FC, useEffect, useRef, useState } from 'react';
import router from 'next/router';
import { useScreen } from '@shared/helpers/screen.helper';
import { IGroupTrend } from '@shared/models/groupTrend';
import { useHover } from '@shared/utils/hooks';
import ParallaxContent from './ParallaxContent';
import { Container, TitleWrapper } from './TrendAnimation.style';
interface Props {
  data: IGroupTrend;
}
const TrendAnimation: FC<Props> = ({
  data
}: Props) => {
  const {
    isMobile
  } = useScreen();
  const {
    topContent,
    middleContent,
    bottomContent
  } = data;
  const [isHoverMobile, setIsHoverMobile] = useState(false);
  const [tapPositionMobile, setTapPositionMobile] = useState('');
  const topHoverRef = useRef(null);
  const topSliceHoverDesktop = useHover(topHoverRef);
  const isTopSliceHover = isMobile ? isHoverMobile && tapPositionMobile === 'top' : topSliceHoverDesktop;
  const middleHoverRef = useRef(null);
  const middleSliceHoverDesktop = useHover(middleHoverRef);
  const isMiddleSliceHover = isMobile ? isHoverMobile && tapPositionMobile === 'middle' : middleSliceHoverDesktop;
  const bottomHoverRef = useRef(null);
  const bottomSliceHoverDesktop = useHover(bottomHoverRef);
  const isBottomSliceHover = isMobile ? isHoverMobile && tapPositionMobile === 'bottom' : bottomSliceHoverDesktop;
  useEffect(() => {
    window.removeEventListener('scroll', onScroll);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
  }, [isHoverMobile]);
  const onScroll = () => {
    if (isHoverMobile) setIsHoverMobile(false);
  };
  const handleOnClickContent = (slugUrl: string) => {
    if (isMobile) {
      setIsHoverMobile(!isHoverMobile);
    }
    router.push(`/recipe-group/${slugUrl}`);
  };
  return <Container>
            <TitleWrapper>ไอเดียทำอาหารพร้อมเสิร์ฟใหม่ทุกวัน</TitleWrapper>
            <div ref={topHoverRef} onClick={() => setTapPositionMobile('top')}>
                <ParallaxContent baseVelocity={isTopSliceHover ? 0 : -1} content={[...topContent, ...topContent, ...topContent, ...topContent]} isHover={isTopSliceHover} onClickContent={handleOnClickContent} />
            </div>
            <div ref={middleHoverRef} onClick={() => setTapPositionMobile('middle')}>
                <ParallaxContent baseVelocity={isMiddleSliceHover ? 0 : 1} content={[...middleContent, ...middleContent, ...middleContent, ...middleContent]} isHover={isMiddleSliceHover} onClickContent={handleOnClickContent} />
            </div>
            <div ref={bottomHoverRef} onClick={() => setTapPositionMobile('bottom')}>
                <ParallaxContent baseVelocity={isBottomSliceHover ? 0 : -1} content={[...bottomContent, ...bottomContent, ...bottomContent, ...bottomContent]} isHover={isBottomSliceHover} onClickContent={handleOnClickContent} />
            </div>
        </Container>;
};
export default TrendAnimation;